import { render, staticRenderFns } from "./Ancillaries.vue?vue&type=template&id=0a8ba2a4&scoped=true"
import script from "./Ancillaries.vue?vue&type=script&lang=js"
export * from "./Ancillaries.vue?vue&type=script&lang=js"
import style0 from "./Ancillaries.vue?vue&type=style&index=0&id=0a8ba2a4&prod&lang=scss&scoped=true"
import style1 from "./Ancillaries.vue?vue&type=style&index=1&id=0a8ba2a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8ba2a4",
  null
  
)

export default component.exports